import { type PureAbility } from "@casl/ability";
import { type FetchCompanyRolePermissionsResult } from "~/services/role-permissions/fetchCompanyRolePermissions";
import { type SubscriptionStatusWithPermissions } from "~/services/subscriptions/validateSubscription";
export const Action = {
  Access: "access",
  Update: "update",
} as const;

export type Action = (typeof Action)[keyof typeof Action];

export const Subject = {
  Users: "users",
  Account: "account",
  RawData: "rawData",
  Settings: "settings",
  MarketData: "marketData",
  MarketData_Comptryx: "marketData_comptryx",
  Integrations: "integrations",
  PeopleDashboard: "peopleDashboard",
  PeopleDashboard_MarketData: "peopleDashboard_marketData",
  PeopleDashboard_SalaryBands: "peopleDashboard_salaryBands",
  PeopleDashboard_Comptryx: "peopleDashboard_comptryx",
  CompanyDashboard: "companyDashboard",
  CompensationReview: "compensationReview",
  SalaryBands: "salaryBands",
  ImportedEmployees: "importedEmployees",
  FileManager: "fileManager",
  GenderPayGapReport: "genderPayGapReport",
  UserImpersonation: "userImpersonation",
} as const;

export type Subject = (typeof Subject)[keyof typeof Subject];

export type AppAbility = PureAbility<[Action, Subject]>;

export type AbilityParams = {
  subscriptions: SubscriptionStatusWithPermissions;
  rolePermissions?: FetchCompanyRolePermissionsResult;
};
